/**
 * @generated SignedSource<<2dce232c7d2a49be2064619f014c6867>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LessonsFiltersModalFragment_facility$data = {
  readonly " $fragmentSpreads": FragmentRefs<"LessonsFiltersFragment_facility">;
  readonly " $fragmentType": "LessonsFiltersModalFragment_facility";
};
export type LessonsFiltersModalFragment_facility$key = {
  readonly " $data"?: LessonsFiltersModalFragment_facility$data;
  readonly " $fragmentSpreads": FragmentRefs<"LessonsFiltersModalFragment_facility">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LessonsFiltersModalFragment_facility",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LessonsFiltersFragment_facility"
    }
  ],
  "type": "Facility",
  "abstractKey": null
};

(node as any).hash = "463030df75f7206bf394ebe38e259c7c";

export default node;
